document.addEventListener('DOMContentLoaded', () => {
  const dialog = document.getElementById('product-video-dialog');
  if (!dialog) return;

  const videoContainer = document.getElementById('product-video-container');
  const btnClose = document.getElementById('btn-close-product-dialog');
  const btnMute = document.getElementById('btn-mute-product-dialog');
  const btnPlayPauseOverlay = document.getElementById('btn-play-pause-product-overlay');
  const buttons = document.querySelectorAll('.video-thumbnail-btn');

  let currentVideo = null;

  buttons.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const videoUrl = btn.getAttribute('data-video-url');
      if (!videoUrl) return;

      const posterUrl = btn.getAttribute('data-poster-url');

      // Pre-emptively set aspect ratio based on the thumbnail image if it exists
      // This prevents the dialog from rendering small before loadedmetadata fires
      const img = btn.querySelector('img');
      if (img && img.naturalWidth && img.naturalHeight) {
        videoContainer.style.aspectRatio = `${img.naturalWidth} / ${img.naturalHeight}`;
        
        // Determine if it's non-vertical (9:16 is 0.5625)
        const ratio = img.naturalWidth / img.naturalHeight;
        if (ratio > 0.6) {
          videoContainer.classList.add('is-non-vertical');
        }
      } else {
        // Fallback to vertical default if image hasn't loaded yet somehow
        videoContainer.style.aspectRatio = '9 / 16';
      }

      currentVideo = document.createElement('video');
      currentVideo.src = videoUrl;
      if (posterUrl) {
        currentVideo.poster = posterUrl;
      }
      
      currentVideo.autoplay = true;
      currentVideo.playsInline = true;
      currentVideo.muted = false;

      currentVideo.addEventListener('loadedmetadata', () => {
        // Correct the aspect ratio to perfectly match the video once loaded
        videoContainer.style.aspectRatio = `${currentVideo.videoWidth} / ${currentVideo.videoHeight}`;
        
        // Final check based on actual video metadata
        const ratio = currentVideo.videoWidth / currentVideo.videoHeight;
        if (ratio > 0.6) {
          videoContainer.classList.add('is-non-vertical');
        } else {
          videoContainer.classList.remove('is-non-vertical');
        }
      });

      // Toggle play/pause on video click
      currentVideo.addEventListener('click', () => {
        if (currentVideo.paused) {
          currentVideo.play();
        } else {
          currentVideo.pause();
        }
      });

      currentVideo.addEventListener('play', () => {
        videoContainer.classList.remove('is-paused');
      });
      
      currentVideo.addEventListener('pause', () => {
        videoContainer.classList.add('is-paused');
      });

      currentVideo.addEventListener('volumechange', () => {
        if (currentVideo.muted) {
          btnMute.classList.add('is-muted');
        } else {
          btnMute.classList.remove('is-muted');
        }
      });

      const playPromise = currentVideo.play();
      if (playPromise !== undefined) {
        playPromise.catch(() => {
          videoContainer.classList.add('is-paused');
        });
      }

      // Ensure video is inserted BEFORE the controls so controls sit on top visually
      videoContainer.insertBefore(currentVideo, btnClose);
      dialog.showModal();
    });
  });

  const cleanupDialog = () => {
    if (currentVideo) {
      currentVideo.remove();
      currentVideo = null;
    }
    videoContainer.classList.remove('is-paused');
    videoContainer.classList.remove('is-non-vertical');
    videoContainer.style.aspectRatio = ''; // Reset aspect ratio
    btnMute.classList.remove('is-muted'); // Reset mute button UI state
  };

  const closeDialog = () => {
    dialog.close();
  };

  // Listen to the native 'close' event (fires on Esc key or dialog.close())
  dialog.addEventListener('close', cleanupDialog);

  btnClose.addEventListener('click', closeDialog);
  
  dialog.addEventListener('click', (e) => {
    if (e.target === dialog || e.target.classList.contains('product-video-dialog-inner')) {
      closeDialog();
    }
  });

  btnPlayPauseOverlay.addEventListener('click', () => {
    if (!currentVideo) return;
    if (currentVideo.paused) {
      currentVideo.play();
    } else {
      currentVideo.pause();
    }
  });

  btnMute.addEventListener('click', () => {
    if (!currentVideo) return;
    currentVideo.muted = !currentVideo.muted;
  });
});
